import saveIcon from "../../../../../assets/save.svg";
import cancelIcon from "../../../../../assets/cancel.svg";
import React from "react";

interface EditingStateProps {
    editedChatName: string;
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleSaveEditClick: (event: React.MouseEvent | React.KeyboardEvent) => void; // Updated props type
    handleCancelEditClick: (event: React.MouseEvent) => void;
}

const EditingState: React.FC<EditingStateProps> = ({ editedChatName, handleInputChange, handleSaveEditClick, handleCancelEditClick }) => {
    const onKeyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSaveEditClick(event);
        }
    };

    return (
        <div className="flex items-center gap-2 w-full">
            <input
                type="text"
                value={editedChatName}
                onChange={handleInputChange}
                onClick={(event) => event.stopPropagation()}
                onKeyDown={onKeyDownHandler} // Added onKeyDown handler
                className="rounded border border-neutral-300 dark:border-neutral-700 px-2 py-1 w-full max-w-[calc(100%-4rem)] dark:bg-neutral-800 dark:text-neutral-100"
            />
            <div className="flex items-center ml-1 space-x-1">
                <button onClick={handleSaveEditClick} className="p-1 hover:bg-neutral-200 dark:hover:bg-neutral-700 rounded-full">
                    <img src={`${saveIcon}`} alt="Save" className="h-4 w-4"/>
                </button>
                <button onClick={handleCancelEditClick} className="p-1 hover:bg-neutral-200 dark:hover:bg-neutral-700 rounded-full">
                    <img src={`${cancelIcon}`} alt="Cancel" className="h-5 w-5"/>
                </button>
            </div>
        </div>
    );
};

export default EditingState;
